import PageTitle from "../MainContents/PageTitle/PageTitle";
import styled from 'styled-components';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 
import { device } from '../MainContents/Style/StyleDevice';

const svgNext =<svg className="h-5 w-5 text-white rounded inline"  fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/></svg>
const Main =styled.div`
    margin-top: 100px;
    width: 90%;
    margin: auto;
    @media ${device.mobile}{
        width: 100%;
    }
`


const LavelDiv = styled.div`
    text-align: center;
    align-self: center;
`

const FormScope = styled.div`
    max-width: 800px;
    width: 100%;
    margin: 30px auto;
    @media ${device.mobile}{
        width: 100%;
    }
`
const LavelName = styled.div`
    @media ${device.mobile}{
    float: left;
    }
`
const Mt =styled.div`
margin-top:130px;
@media ${device.mobile}{
  margin-top:80px;
  }
`;
const InputText = styled.textarea`width:100%;`
const Input = styled.input`width: 100%;`
const Select = styled.select`width: 100%;`
const Contact: React.VFC = () => {
  return (
    <Main>
        <ScrollToTopOnMount />
           <Mt></Mt>
      <PageTitle title={'お問い合わせ'} englishText={'Contact&Us'} />
      <FormScope>
          ステモン秦校またはイオン高知ステモン旭校へのお問い合わせがある方はこちらのフォームから送りください。
          <form action="https://tosajuku.info/tsjk_webpage/STEMON/mailCheak.php" method="post">
          {/* 名前フォーム */}
          <div className='mt-3 p-2 grid grid-cols-1 lg:grid-cols-1 md:grid-cols-6 xl:grid-cols-6 gap-4'>
            <LavelDiv className='col-span-2 p-2'>
                <LavelName className='font-bold font-sans'>お名前(お子様名)</LavelName>
            </LavelDiv>
            <div className='col-span-4 p-2'>
                <Input type="text" className="border rounded p-3" placeholder="お子様のお名前" name="student_name" required/>
            </div>
          </div>

          {/* 性別 */}
          <div className='mt-3 p-2 grid grid-cols-1 lg:grid-cols-1 md:grid-cols-6 xl:grid-cols-6 gap-4'>
            <LavelDiv className='col-span-2 p-2'>
                <LavelName className='font-bold font-sans'>性別</LavelName>
            </LavelDiv>
            <div className='col-span-4 p-2'>
                <Select name="gender" id="" className="border rounded p-3" placeholder="性別を選択してください" required>
                    <option value="">性別をしてください</option>
                    <option value="m">男</option>
                    <option value="l">女</option>
                </Select>
            </div>
          </div>

          {/* 教室*/}
          <input type="hidden" name="schools" value="hada" />
          {/* <div className='mt-3 p-2 grid grid-cols-1 lg:grid-cols-1 md:grid-cols-6 xl:grid-cols-6 gap-4'>
            <LavelDiv className='col-span-2 p-2'>
                <LavelName className='font-bold font-sans'>校舎選択</LavelName>
            </LavelDiv>
            <div className='col-span-4 p-2'>
                <Select name="schools" id="" className="border rounded p-3" placeholder="校舎を選択してください" required>
                    <option value="">下記の中からお選びください</option>
                    <option value="ionAsahi">イオン高知ステモン旭町校</option>
                    <option value="hada">ステモン秦校</option>
                </Select>
            </div>
          </div> */}

          {/* 通園・通学先*/}
          <div className='mt-3 p-2 grid grid-cols-1 lg:grid-cols-1 md:grid-cols-6 xl:grid-cols-6 gap-4'>
            <LavelDiv className='col-span-2 p-2'>
                <LavelName className='font-bold font-sans'>通園・通学先</LavelName>
            </LavelDiv>
            <div className='col-span-4 p-2'>
                <Input type="text" className="border rounded p-3" placeholder="保育/幼稚園・学校名" name="school" />
            </div>
          </div>

          {/* お子様の学年*/}
          <div className='mt-3 p-2 grid grid-cols-1 lg:grid-cols-1 md:grid-cols-6 xl:grid-cols-6 gap-4'>
            <LavelDiv className='col-span-2 p-2'>
                <LavelName className='font-bold font-sans'>学年</LavelName>
            </LavelDiv>
            <div className='col-span-4 p-2'>
                <Select name="grade" id="" className="border rounded p-3" placeholder="学年を選択してください" required>
                    {/* <option value="">2023年４月からの学年を選択してください</option> */}
                    <option value="">学年を選択してください</option>
                    <option value="99">年中</option>
                    <option value="50">年長</option>
                    <option value="1">１年生</option>
                    <option value="2">２年生</option>
                    <option value="3">３年生</option>
                    <option value="4">４年生</option>
                    <option value="5">５年生</option>
                    <option value="6">６年生</option>
                </Select>
            </div>
          </div>

         {/* 住所*/}
        <div className='mt-3 p-2 grid grid-cols-1 lg:grid-cols-1 md:grid-cols-6 xl:grid-cols-6 gap-4'>
            <LavelDiv className='col-span-2 p-2'>
                <LavelName className='font-bold font-sans'>住所</LavelName>
            </LavelDiv>
            <div className='col-span-4 p-2'>
                <Input type="text" className="border rounded p-3" placeholder="ご住所" name="address"/>
            </div>
        </div>

         {/* 電話番号*/}
        <div className='mt-3 p-2 grid grid-cols-1 lg:grid-cols-1 md:grid-cols-6 xl:grid-cols-6 gap-4'>
            <LavelDiv className='col-span-2 p-2'>
                <LavelName className='font-bold font-sans'>電話番号</LavelName>
            </LavelDiv>
            <div className='col-span-4 p-2'>
                <Input type="text" className="border rounded p-3" placeholder="電話番号" name="Tel"/>
            </div>
        </div>

         {/* メールアドレス */}
        <div className='mt-3 p-2 grid grid-cols-1 lg:grid-cols-1 md:grid-cols-6 xl:grid-cols-6 gap-4'>
            <LavelDiv className='col-span-2 p-2'>
                <LavelName className='font-bold font-sans'>メールアドレス</LavelName>
            </LavelDiv>
            <div className='col-span-4 p-2'>
                <Input type="text" className="border rounded p-3" placeholder="info@sample.com" name="mail"/>
            </div>
        </div>

         {/* お問い合わせ内容 */}
        <div className='mt-3 p-2 grid grid-cols-1 lg:grid-cols-1 md:grid-cols-6 xl:grid-cols-6 gap-4'>
            <LavelDiv className='col-span-2 p-2'>
                <LavelName className='font-bold font-sans'>お問い合わせ内容</LavelName>
            </LavelDiv>
            <div className='col-span-4 p-2'>
                <InputText className="border rounded-md p-3 resize-x " name="message"></InputText>
            </div>
        </div>

        <div className="text-center">
                <button className="font-bold bg-orange-400 text-white p-5 rounded">入力内容を確認&ensp;{svgNext}</button>
        </div>
        </form>
      </FormScope>
    </Main>
    
  );
}
export default Contact;